import apiService from 'services/apiService';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const getConversations = (companyId, excludeInsights, updatedSince, managerId) => {
  const updatedSinceQuery = updatedSince ? `&updatedSince=${updatedSince}` : '';
  const managerIdQuery = managerId ? `&managerId=${managerId}` : '';

  const url = `${baseUrl}/v1/entities/${companyId}/introducer/clients/conversations?excludeInsights=${excludeInsights}${updatedSinceQuery}${managerIdQuery}`;
  return apiService.get(url);
};

export { getConversations };
